module.exports = __webpack_public_path__ + "media/images/ipaf-poster-13f9d58a6601b626cfafbbe1365c08cf.jpeg";